/* eslint-disable @typescript-eslint/naming-convention */
'use client';

import Image from 'next/image';
import Link from 'next/link';

import { Accordion } from '@gds/Accordion/Accordion';
import Button from '@gds/Button/Button';

import type { BuyOnlineContent } from './Entities/BuyOnlineModal.entity';

import styles from './BuyOnlineModal.module.css';

interface BuyOnlineModalProps {
  buyOnlineModalData: BuyOnlineContent;
}

export const BuyOnlineModal = ({ buyOnlineModalData }: BuyOnlineModalProps) => {
  const { step: steps, faqs, linkedCta } = buyOnlineModalData;
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.innerWrapper}>
          {steps?.map(step => {
            if (!step) return false;
            return (
              <li key={step.headline}>
                {step.iconOrImage[0] && (
                  <div className={styles.imageContainer}>
                    <Image src={step.iconOrImage[0]} alt={'Icon'} fill />
                  </div>
                )}
                <div className={styles.content}>
                  <h3>{step.headline}</h3>

                  <div dangerouslySetInnerHTML={{ __html: step.bodycontent || '' }} />
                </div>
              </li>
            );
          })}
        </div>

        {faqs?.map(faq => {
          return (
            <Accordion key={faq.question} title={faq.question}>
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: faq.answer || '' }}
              />
            </Accordion>
          );
        })}
      </div>
      {linkedCta[0].ctaText && (
        <div className={styles.ctaWrapper}>
          <Button
            className={styles.cta}
            Component={Link}
            href={linkedCta[0].link ?? '/'}
            target="_blank"
          >
            {linkedCta[0].ctaText}
          </Button>
        </div>
      )}
    </>
  );
};
